import { useNavigate, useSearchParams } from "react-router-dom";

export const useInvoiceActionNavigation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const goTo = (path: string, options?: any) => {
    navigate(path, options);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goForward = () => {
    navigate(1);
  };

  const pdcId = searchParams.get("pdcId");

  return {
    goTo,
    goBack,
    goForward,
    pdcId,
  };
};
